import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface RerunInfoBannerProps {
  canRerunEverything: boolean;
  hasRunInProgress: boolean;
  isScopedRerun: boolean;
}

export const RerunInfoBanner = ({
  canRerunEverything,
  hasRunInProgress,
  isScopedRerun,
}: RerunInfoBannerProps) => (
  <Alert color="information" role="status">
    <InfoIcon />
    <AlertDescription>
      <Stack className="w-full" align="start" gap={1}>
        <Text variant="caption">
          <b>This may take a few minutes.</b>{" "}
          {!canRerunEverything
            ? "Full payroll must be recalculated even when only rerunning your section."
            : hasRunInProgress
              ? "Another payroll run is in progress. This run will begin when it finishes."
              : "If another payroll run starts first, this run will begin when it finishes."}
        </Text>
        {isScopedRerun && (
          <Text variant="caption">
            <b>Shared dependencies can recalculate related sheets.</b>
          </Text>
        )}
        {isScopedRerun && (
          <Text variant="caption">
            <b>Changed approved units need approval again.</b> An approval stays
            in place when its payroll content does not change.
          </Text>
        )}
        <Text variant="caption">
          <b>Your manual edits are kept</b> and re-applied. Any edit whose
          underlying numbers changed is flagged for review, and any whose row no
          longer appears is listed as dropped.
        </Text>
      </Stack>
    </AlertDescription>
  </Alert>
);
